<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          검출의뢰 상세
        </div>
        <div>
          <item-write-component :item-type="`detectionRequestDetail`":itemKey="itemKey"></item-write-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ItemWriteComponent from "@/components/item/ItemWriteComponent";

export default {
  name: "DetectionRequestDetail",
  mixins: [],
  components: {
    ItemWriteComponent
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{
        itemKey : this.$route.params.idx

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>
